// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
/**
 * 系统内置方法集（对齐 EB view/admin/src/utils/system.js）
 */

/** 多级嵌套数组处理成一维数组 */
export const formatFlatteningRoutes = (arr: unknown[]) => {
  if (!Array.isArray(arr) || arr.length <= 0) return false;
  let list = arr as Array<Record<string, unknown>>;
  for (let i = 0; i < list.length; i++) {
    const children = list[i].children as typeof list | undefined;
    if (children) {
      list = list.slice(0, i + 1).concat(children, list.slice(i + 1));
    }
  }
  return list;
};
